import { render, staticRenderFns } from "./GlobalButton.vue?vue&type=template&id=e509c11a"
import script from "./GlobalButton.vue?vue&type=script&lang=js"
export * from "./GlobalButton.vue?vue&type=script&lang=js"
import style0 from "./GlobalButton.vue?vue&type=style&index=0&id=e509c11a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports